<template>
  <div>
    <div class="mb-3">
      <div class="d-flex align-center" style="gap: 6px; margin: 0 0 2px 0">
        <h3 style="font-size: 16px; font-weight: 700; margin: 0; color: #0f3565">
          {{ $t('Ordens de serviço abertas por dia') }}
        </h3>
        <v-tooltip color="white" bottom max-width="320">
          <template v-slot:activator="{ on, attrs }">
            <v-icon small color="rgba(0,0,0,0.4)" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
          </template>
          <span class="black--text">
            <p class="mb-0 mt-2" style="font-size: 0.9rem">{{ $t("Apresenta o número de O.S.'s que foram abertas nos últimos 30 dias.") }}</p>
          </span>
        </v-tooltip>
      </div>
      <span style="color: rgba(0,0,0,0.5); font-size: 11px">
        {{ $t('Últimos 30 dias') }}
      </span>

    </div>

    <div v-if="loading" class="d-flex justify-center align-center" style="height: 300px">
      <v-progress-circular indeterminate color="#bbcf20" size="40" />
    </div>

    <div v-else-if="isEmpty" class="d-flex flex-column justify-center align-center" style="height: 300px">
      <v-icon color="rgba(0,0,0,0.2)" size="48">mdi-chart-line</v-icon>
      <span style="color: rgba(0,0,0,0.4); font-size: 13px; margin-top: 8px">
        {{ $t('Nenhum dado encontrado') }}
      </span>
    </div>

    <v-chart
      v-else
      :option="chartOption"
      :autoresize="true"
      style="height: 320px; width: 100%"
    />
  </div>
</template>

<script>
import VChart from 'vue-echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'
import { TooltipComponent, GridComponent } from 'echarts/components'
import ApiService from '../../../../services/ApiService'

use([CanvasRenderer, LineChart, TooltipComponent, GridComponent])

export default {
  name: 'ServiceOrdersOpenedByDay',

  components: { VChart },

  props: {
    filterProp: { type: Object, default: () => ({}) },
  },

  data: () => ({
    loading: false,
    chartOption: {},
    apiService: new ApiService(),
  }),

  computed: {
    isEmpty() {
      return !this.chartOption.series || this.chartOption.series.length === 0
    },
  },

  watch: {
    filterProp: {
      handler() {
        this.load()
      },
      deep: true,
    },
  },

  created() {
    this.load()
  },

  methods: {
    async load() {
      this.loading = true
      try {
        const response = await this.apiService.post(
          'dashboardBI/service-orders-opened-by-day',
          this.filterProp
        )
        const { data } = response.content
        this.buildChart(data || [])
      } catch (err) {
        // errors handled globally by ApiService
      } finally {
        this.loading = false
      }
    },

    buildChart(data) {
      if (!data.length) {
        this.chartOption = {}
        return
      }

      const dates = data.map((d) => d.date)
      const counts = data.map((d) => d.count)

      this.chartOption = {
        animationDuration: 600,
        animationEasing: 'cubicOut',
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(10,30,60,0.92)',
          borderColor: 'rgba(255,255,255,0.1)',
          textStyle: { color: '#fff', fontSize: 12 },
          formatter: (params) => {
            const p = params[0]
            return `<b>${p.axisValue}</b><br/><span style="display:inline-block;width:8px;height:8px;border-radius:50%;background:${p.color};margin-right:5px"></span>${this.$t('O.S. abertas')}: <b>${p.value}</b>`
          },
        },
        grid: { top: 32, right: 16, bottom: 32, left: 16, containLabel: true },
        xAxis: {
          type: 'category',
          data: dates,
          axisLabel: {
            color: 'rgba(0,0,0,0.6)',
            fontSize: 10,
            interval: 4,
          },
          axisLine: { lineStyle: { color: 'rgba(0,0,0,0.15)' } },
          splitLine: { show: false },
        },
        yAxis: {
          type: 'value',
          axisLabel: { color: 'rgba(0,0,0,0.6)', fontSize: 11 },
          axisLine: { show: false },
          splitLine: { lineStyle: { color: 'rgba(0,0,0,0.08)' } },
          minInterval: 1,
        },
        series: [
          {
            name: this.$t('O.S. abertas'),
            type: 'line',
            data: counts,
            smooth: false,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#BBCF20', width: 2 },
            itemStyle: { color: '#BBCF20' },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(187,207,32,0.3)' },
                  { offset: 1, color: 'rgba(187,207,32,0.02)' },
                ],
              },
            },
            label: {
              show: true,
              position: 'top',
              color: 'rgba(0,0,0,0.65)',
              fontSize: 10,
              formatter: ({ value }) => (value > 0 ? value : ''),
            },
          },
        ],
      }
    },
  },
}
</script>
